import { t } from "@travily/i18n";
import { ButtonDock } from "@ui/components/ButtonDock";
import { Dialog } from "@ui/components/Dialog";
import { Icon } from "@ui/components/Icon";
import { StandardButton } from "@ui/components/StandardButton";
import { StandardTextField } from "@ui/components/StandardTextField";
import type { FormEvent } from "react";

export interface GuestCheckoutModalProps {
  email: string;
  emailError?: string;
  free: boolean;
  isPending: boolean;
  kind: "product" | "service";
  onClose: () => void;
  onEmailChange: (value: string) => void;
  onSubmit: () => void;
}

// i18n-tasks-use t('components.views.products.guest_checkout_modal.title_product')
// i18n-tasks-use t('components.views.products.guest_checkout_modal.title_service')
// i18n-tasks-use t('components.views.products.guest_checkout_modal.description_product')
// i18n-tasks-use t('components.views.products.guest_checkout_modal.description_service')
// i18n-tasks-use t('components.views.products.guest_checkout_modal.submit_paid_product')
// i18n-tasks-use t('components.views.products.guest_checkout_modal.submit_paid_service')
// i18n-tasks-use t('components.views.products.guest_checkout_modal.submit_free_product')
// i18n-tasks-use t('components.views.products.guest_checkout_modal.submit_free_service')
export function GuestCheckoutModal({
  email,
  emailError,
  free,
  isPending,
  kind,
  onClose,
  onEmailChange,
  onSubmit,
}: GuestCheckoutModalProps) {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit();
  };

  const description = t(`components.views.products.guest_checkout_modal.description_${kind}`);
  const submitLabel = free
    ? t(`components.views.products.guest_checkout_modal.submit_free_${kind}`)
    : t(`components.views.products.guest_checkout_modal.submit_paid_${kind}`);

  return (
    <form className="flex h-full flex-col" noValidate onSubmit={handleSubmit}>
      <Dialog.Header onClose={onClose} title={t(`components.views.products.guest_checkout_modal.title_${kind}`)} />
      <Dialog.Body>
        <div className="px-1">
          <StandardTextField
            autoComplete="email"
            autoFocus
            description={description}
            errorMessage={emailError}
            isInvalid={emailError !== undefined}
            label={t("components.views.products.guest_checkout_modal.email_label")}
            leadIcon={<Icon name="mail" type="sticker" />}
            name="email"
            onChange={onEmailChange}
            placeholder={t("components.views.products.guest_checkout_modal.email_placeholder")}
            type="email"
            value={email}
          />
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <ButtonDock
          primaryAction={
            <StandardButton color="pink" isPending={isPending} size="44" type="submit">
              {submitLabel}
            </StandardButton>
          }
        />
      </Dialog.Footer>
    </form>
  );
}
